import { Link } from "gatsby"
import React from "react"
import flatartLogo from "../assets/img/flatart-logo.png"

const Footer = () => (
    <footer>

        <div className="footer-bottom">
            <div className="footer-bottom_content">
                <h2>Let’s Meet.</h2>
                <p>You can reach us via <a href="mailto:hello@theflatart.com" >e-mail</a> or <a href="tel:+905335777239">phone</a></p>
                <p>or come over to our agency for a cup of coffee!</p>
            </div>
            <div className="footer-bottom_links container">
                <div className="col-md-3 social" style={{ textAlign: "center" }}>
                    <img className="footer-logo" alt="Flatart logo" src={flatartLogo} />
                    <p><u><a href="https://www.instagram.com/flatart.agency">Ins.</a></u> <u><a href="https://dribbble.com/flatart">Drb.</a></u> <u><a href="http://www.faceobok.com/flatart.agency">Fck.</a></u> <u><a href="https://www.linkedin.com/company/flatart-agency">In.</a></u></p>
                </div>
                <div className="col-md-3">
                    <h3>Services</h3>
                    <ul>
                    <li><Link to="/search-engine-optimization/">Search Engine Optimization</Link></li>
                    <li><Link to="/web-development/">Web & Mobile Development</Link></li>
                    <li><Link to="/social-media/">Social media management</Link></li>
                    <li><Link to="/email-marketing/">Email Marketing</Link></li>
                    <li><Link to="/ui-ux-design/">UI/UX Design</Link></li>
                    <li><Link to="/digital-ads/">Digital Ads</Link></li>


                    </ul>
                </div>
               
                <div className="col-md-3">
                    <h3>Solutions</h3>
                    <ul>
                        <li><Link to="/acquisition/">Acquisition</Link></li>
                        <li><Link to="/conversion/">Conversion</Link></li>
                        <li><Link to="/analysis/">Analysis</Link></li>
                    </ul>
                </div>
                <div className="col-md-3">
                    <h3>Flatart Agency</h3>
                    <ul>
                        <li><Link to="/about/">About us</Link></li>
                        <li><Link to="/about/">Let's meet</Link></li>
                        <li><Link to="/brands/">Brands</Link></li>
                        <li><Link to="/contact/">Contact</Link></li>
                        <li><Link to="/about/#ekip">Team</Link></li>
                        <li><Link to="/about/#ik">HR</Link></li>
                    </ul>
                </div>
               
            </div>
            <div className="footer-bottom_end">
                <div className="footer-bottom_end-content container">
                    <p>Flatart 2020 All rights reserved.</p>
                    <ul>
                    <li><Link to="/privacy-policy/">Privacy Policy</Link></li>
                        <li><Link to="/terms-of-use/">Terms of Use</Link></li>
                        <li><a target="_blank" href="https://popupsmart.com">Popupsmart</a></li>
                        {/* <li><Link to="#">Gizlilik Sözleşmesi</Link></li> */}
                        {/* <li><Link to="#">Kullanım Koşulları</Link></li> */}
                    </ul>
                </div>
            </div>
            
        </div>

    </footer>

)

export default Footer
